<!--
 * @Author: cuixi
-->
<!-- 首页导航 -->
<template>
  <div class="nav">
    <ul>
      <li
        v-for="i in navArr"
        :key="i.index"
        :class="[i.isActive ? 'nav_text_active' : 'nav_text']"
        @click="navClick(i)"
      >
        {{ i.text }}
      </li>
    </ul>
  </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      navArr: [
        {
          text: "首页",
          path: "/home",
          isActive: true,
        },
        {
          text: "养生保健",
          path: "/healthCare",
          isActive: false,
        },
        {
          text: "膳食营养",
          path: "/dietaryNutrition",
          isActive: false,
        },
        {
          text: "运动健身",
          path: "/sport",
          isActive: false,
        },
        {
          text: "健康科普",
          path: "/sciencePopularization",
          isActive: false,
        },
        {
          text: "健康培训",
          path: "/education",
          isActive: false,
        },
        {
          text: "健康技法",
          path: "/healthTechniques",
          isActive: false,
        },
        {
          text: "健康整合",
          path: "/healthIntegration",
          isActive: false,
        },
        {
          text: "心理健康",
          path: "/mentalHealth",
          isActive: false,
        },
        {
          text: "康复训练",
          path: "/training",
          isActive: false,
        },
        {
          text: "健康管理",
          path: "/healthManagement",
          isActive: false,
        },
        {
          text: "线下保健",
          path: "/offlineHealthcare",
          isActive: false,
        },
        {
          // text: "学术活动",
          text: "活动会务",
          path: "/academicActivities",
          isActive: false,
        },
      ],
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    // 点击导航
    navClick(val) {
      this.navArr.forEach((i) => {
        if (i.text == val.text) {
          i.isActive = true;
          sessionStorage.setItem("path", i.path);
        } else {
          i.isActive = false;
        }
      });
      this.$router.push(val.path);
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    // 解决刷新页面后导航选中问题
    if (sessionStorage.getItem("path")) {
      this.navArr.forEach((i) => {
        if (i.path == sessionStorage.getItem("path")) {
          i.isActive = true;
        } else {
          i.isActive = false;
        }
      });
    }
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang="scss" scoped>
//@import url(); 引入公共css类
.nav {
  width: 100%;
  height: 58px;
  background: #3878f8;
  padding: 0;
  display: flex;
  justify-content: center;
  ul {
    width: 1200px;
    margin: 0 auto;
    display: flex;
  }
  .nav_text {
    display: inline-block;
    width: 92px;
    height: 58px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 18px;
    color: #ffffff;
    line-height: 58px;
    text-align: center;
    cursor: pointer;

    &:hover {
      font-weight: 700;
      background: rgba(0, 0, 0, 0.08);
    }
  }

  .nav_text_active {
    display: inline-block;
    width: 92px;
    height: 58px;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 700;
    font-size: 18px;
    color: #ffffff;
    line-height: 58px;
    text-align: center;
    background: rgba(0, 0, 0, 0.08);
    cursor: pointer;
  }
}
</style>
